import { render, staticRenderFns } from "./Idea_comment_block.vue?vue&type=template&id=6ff66426"
import script from "./Idea_comment_block.vue?vue&type=script&lang=js"
export * from "./Idea_comment_block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports